module.exports = __webpack_public_path__ + "static/img/about.0561c626.png";